
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(duration)
dayjs.extend(utc)
dayjs.extend(timezone)

export default {
    props: {
        endDate: {
            type: String,
            default: '',
        },
        isExpired: {
            type: Boolean,
            default: true,
        },
        timezone: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            timeLeft: {
                days: '0',
                h: '00',
                m: '00',
                s: '00',
            },
            intervalId: null,
        }
    },
    mounted() {
        this.updateTime()
        this.intervalId = setInterval(this.updateTime, 1000)
    },
    beforeDestroy() {
        clearInterval(this.intervalId)
    },
    methods: {
        updateTime() {
            let actualDate = dayjs(this.endDate)
                .endOf('day')
                .format('YYYY-MM-DD HH:mm:ss')
            let endDateDayJs = dayjs(actualDate)

            if (!this.isExpired) {
                actualDate = dayjs(this.endDate)
                    .startOf('day')
                    .format('YYYY-MM-DD HH:mm:ss')
                endDateDayJs = dayjs(actualDate)
            }

            // Convert the selected timezone into local time

            endDateDayJs = dayjs
                .tz(endDateDayJs.format('YYYY-MM-DD HH:mm:ss'), this.timezone)
                .local()

            const now = dayjs()

            const diffInMilliseconds = endDateDayJs.diff(now)

            if (diffInMilliseconds <= 0) {
                this.timeLeft = {
                    days: '0',
                    h: '00',
                    m: '00',
                    s: '00',
                }
                clearInterval(this.intervalId)
                return
            }

            const remaining = dayjs.duration(diffInMilliseconds)

            this.timeLeft = {
                days: String(Math.floor(remaining.asDays() || 0)),
                h: String(remaining.hours()).padStart(2, '0'),
                m: String(remaining.minutes()).padStart(2, '0'),
                s: String(remaining.seconds()).padStart(2, '0'),
            }
        },
    },
}
